import type { FeatureRequestActivity } from '../../../../shared/models/feature-request.models';

export function featureRequestActivityTitle(item: FeatureRequestActivity): string {
  const user = item.performedByUser?.displayName ?? item.performedBy;
  const actionLabels: Record<string, string> = {
    CREATED: 'Feature Request Created',
    STATUS_CHANGED: 'Status changed',
    ASSIGNED: 'Assignment changed',
    PRIORITY_CHANGED: 'Priority changed',
    COMMENT_ADDED: 'Comment Added',
    COMMENT_EDITED: 'Comment edited',
    COMMENT_DELETED: 'Comment deleted',
    ATTACHMENT_UPLOADED: 'Attachment Uploaded',
    CLOSED: 'Request Closed',
  };
  return `${actionLabels[item.action] ?? item.action} — ${user}`;
}

export function featureRequestActivityDetail(item: FeatureRequestActivity): string | null {
  if (item.oldValue && item.newValue) {
    return `${item.oldValue} → ${item.newValue}`;
  }
  if (item.newValue) return item.newValue;
  return null;
}
